import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import Grid from '../../../components/molecules/Grid';
import styles from './style';
import { useScript } from '../../../utils/hooks';
import { canUseDOM } from '../../../utils/canUseDOM';
import { COMPONENT_NAME } from './locators';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { LANGUAGE_CODE, SOCIAL_SHARE_ICONS_SCRIPT_URL } from '../../../../constants';
import Typography from '../../../components/atoms/Typography';
import Container from '../../../components/molecules/Container';
import { evalConditionForSocialShare } from '../../../utils/cookie';
import { get } from 'lodash';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { Box, NoSsr } from '@material-ui/core';

const SocialShare = props => {
  const classes = styles();
  // const key = { value: '655608d1006dec00135f46e8' };
  const key = { value: getDictionaryText('shareThisProperty') };
  const product = getDictionaryText('shareThisProduct');
  const targetClass = { value: getDictionaryText('shareThisProduct') };
  const [showComponent, setShowComponent] = useState(true); // need to revert to false when checked in vaddev
  const isSocialShareAvailable = get(
    props,
    'sitecoreContext.route.fields.isSocialShareAvailable.value',
    ''
  );

  const createSVG = (type = '', customClass = '') => {
    switch (type) {
      case 'twitter':
        return (
          <svg className={customClass} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9882 14.0029C27.9882 21.7321 21.7224 27.9979 13.9931 27.9979C6.26385 27.9979 -0.00195312 21.7321 -0.00195312 14.0029C-0.00195312 6.27361 6.26385 0.0078125 13.9931 0.0078125C21.7224 0.0078125 27.9882 6.27361 27.9882 14.0029ZM12.0612 14.8388L5.37175 5.89453H10.5275L14.913 11.7582L20.3406 5.89453H21.8557L15.5899 12.6637L22.6559 22.111H17.5001L12.7384 15.744L6.84473 22.111H5.32959L12.0612 14.8388ZM9.96834 7.01046H7.59983L18.059 20.9951H20.4275L9.96834 7.01046Z" fill="black" />
          </svg>
        );
      case 'facebook':
        return (
          <svg className={customClass} xmlns="http://www.w3.org/2000/svg" width="14" height="28" viewBox="0 0 14 28" fill="none">
            <path d="M11.2331 5.09453H13.6673V0.854526C13.2474 0.796748 11.803 0.666748 10.1209 0.666748C6.61124 0.666748 4.207 2.87453 4.207 6.9323V10.6667H0.333984V15.4067H4.207V27.3334H8.95549V15.4079H12.6718L13.2618 10.6679H8.95438V7.4023C8.95549 6.0323 9.32435 5.09453 11.2331 5.09453Z" fill="black" />
          </svg>
        );
      case 'whatsapp':
        return (
          <svg className={customClass} xmlns="http://www.w3.org/2000/svg" width="2489" height="2500" viewBox="0 0 737.509 740.824"><path fill-rule="evenodd" clip-rule="evenodd" d="M630.056 107.658C560.727 38.271 468.525.039 370.294 0 167.891 0 3.16 164.668 3.079 367.072c-.027 64.699 16.883 127.855 49.016 183.523L0 740.824l194.666-51.047c53.634 29.244 114.022 44.656 175.481 44.682h.151c202.382 0 367.128-164.689 367.21-367.094.039-98.088-38.121-190.32-107.452-259.707m-259.758 564.8h-.125c-54.766-.021-108.483-14.729-155.343-42.529l-11.146-6.613-115.516 30.293 30.834-112.592-7.258-11.543c-30.552-48.58-46.689-104.729-46.665-162.379C65.146 198.865 202.065 62 370.419 62c81.521.031 158.154 31.81 215.779 89.482s89.342 134.332 89.311 215.859c-.07 168.242-136.987 305.117-305.211 305.117m167.415-228.514c-9.176-4.591-54.286-26.782-62.697-29.843-8.41-3.061-14.526-4.591-20.644 4.592-6.116 9.182-23.7 29.843-29.054 35.964-5.351 6.122-10.703 6.888-19.879 2.296-9.175-4.591-38.739-14.276-73.786-45.526-27.275-24.32-45.691-54.36-51.043-63.542-5.352-9.183-.569-14.148 4.024-18.72 4.127-4.11 9.175-10.713 13.763-16.07 4.587-5.356 6.116-9.182 9.174-15.303 3.059-6.122 1.53-11.479-.764-16.07-2.294-4.591-20.643-49.739-28.29-68.104-7.447-17.886-15.012-15.466-20.644-15.746-5.346-.266-11.469-.323-17.585-.323-6.117 0-16.057 2.296-24.468 11.478-8.41 9.183-32.112 31.374-32.112 76.521s32.877 88.763 37.465 94.885c4.587 6.122 64.699 98.771 156.741 138.502 21.891 9.45 38.982 15.093 52.307 19.323 21.981 6.979 41.983 5.994 57.793 3.633 17.628-2.633 54.285-22.19 61.932-43.616 7.646-21.426 7.646-39.791 5.352-43.617-2.293-3.826-8.41-6.122-17.585-10.714" /></svg>
        );
      case 'telegram':
        return (
          <svg className={customClass} fill="none" height="2500" width="2500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M250 500c138.071 0 250-111.929 250-250S388.071 0 250 0 0 111.929 0 250s111.929 250 250 250z" fill="#34aadf" /><path className='grey' d="M104.047 247.832s125-51.3 168.352-69.364c16.619-7.225 72.977-30.347 72.977-30.347s26.012-10.115 23.844 14.451c-.723 10.116-6.503 45.52-12.283 83.815-8.671 54.191-18.064 113.439-18.064 113.439s-1.445 16.619-13.728 19.509-32.515-10.115-36.127-13.006c-2.891-2.167-54.191-34.682-72.977-50.578-5.058-4.335-10.838-13.005.722-23.121 26.012-23.844 57.081-53.468 75.867-72.254 8.671-8.671 17.341-28.902-18.786-4.336-51.3 35.405-101.878 68.642-101.878 68.642s-11.561 7.225-33.237.722c-21.677-6.502-46.966-15.173-46.966-15.173s-17.34-10.838 12.284-22.399z" fill="#fff" /></svg>
        );
      case 'messenger':
        return (
          <svg className={customClass} width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0015 2C6.36858 2 2 6.12644 2 11.7011C2 14.6169 3.1954 17.1356 5.14023 18.8751C5.30192 19.0215 5.40077 19.2238 5.40843 19.4444L5.4636 21.2245C5.46756 21.3554 5.50365 21.4833 5.56868 21.5969C5.63371 21.7106 5.7257 21.8065 5.83653 21.8762C5.94736 21.9459 6.07364 21.9873 6.20423 21.9968C6.33483 22.0062 6.46575 21.9834 6.58544 21.9303L8.57088 21.0552C8.74023 20.9816 8.92797 20.9671 9.10421 21.0146C10.0161 21.2651 10.987 21.4008 11.9985 21.4008C17.6314 21.4008 22 17.2751 22 11.7004C22 6.12644 17.6322 2 12.0015 2ZM17.2529 9.57854L14.7487 13.5502C14.6544 13.6997 14.5302 13.8281 14.3839 13.9272C14.2376 14.0263 14.0724 14.0941 13.8986 14.1262C13.7248 14.1583 13.5463 14.154 13.3742 14.1137C13.2021 14.0734 13.0403 13.9979 12.8989 13.892L10.9065 12.3992C10.8178 12.3329 10.71 12.2971 10.5992 12.2971C10.4885 12.2971 10.3807 12.3329 10.292 12.3992L7.60383 14.4398C7.24751 14.7119 6.77625 14.282 7.01533 13.9034L9.51954 9.9318C9.61378 9.7823 9.73796 9.65394 9.88427 9.55481C10.0306 9.45568 10.1958 9.38793 10.3696 9.35582C10.5434 9.32371 10.7219 9.32795 10.894 9.36826C11.0661 9.40857 11.2279 9.48408 11.3693 9.59004L13.3617 11.0828C13.4504 11.149 13.5582 11.1849 13.669 11.1849C13.7797 11.1849 13.8875 11.149 13.9762 11.0828L16.6644 9.04215C17.0245 8.76628 17.4958 9.19617 17.2529 9.57854Z" fill="#000000" />
          </svg>
        );
      default:
        return <></>;
    }
  };

  useScript(
    showComponent &&
    isSocialShareAvailable &&
    `${SOCIAL_SHARE_ICONS_SCRIPT_URL}?property=${key ? key.value : ''}&product=${product}`
  );

  useEffect(() => {
    window.handleSocialShareComponentVisibility = () => {
      setShowComponent(true);
    };
    if (window.GTMLoaded) {
      window.handleSocialShareComponentVisibility();
    }
  }, []);

  if (!(showComponent && isSocialShareAvailable)) {
    return <div id="social-share-component"></div>;
  }
  const language = LANGUAGE_CODE.DEFAULT
  if (evalConditionForSocialShare(language)) {
    return null;
  }

  if (!(key && key.value && targetClass && targetClass.value)) {
    console.error('Socialshare key or class name are not provided.');
    return '';
  }
  if (canUseDOM) {
    window.addthis_config = {};
    window.addthis_config.lang = language;
  }

  return (
    <Container>
      <NoSsr>
        <Grid data-locator={COMPONENT_NAME} className={classes.root}>
          <Grid item xs={12} className={classes.header}>
            <Typography variant="h5Bold" component="h2">
              {getDictionaryText('socialShareHeading')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {/* <div className={targetClass.value}></div> */}
            {/* <div class="sharethis-inline-share-buttons"></div> */}
            <Box className={'socialWrapper'}>
              <div class="st-custom-button" data-network="twitter">
                {createSVG('twitter', 'svgInner')}
              </div>
              <div class="st-custom-button" data-network="facebook">
                {createSVG('facebook', 'svgInner')}
              </div>
              <div class="st-custom-button" data-network="messenger">
                {createSVG('messenger', 'svgInner')}
              </div>
              <div class="st-custom-button" data-network="whatsapp">
                {createSVG('whatsapp', 'svgInner')}
              </div>
              <div class="st-custom-button" data-network="telegram">
                {createSVG('telegram', 'svgInner')}
              </div>


            </Box>
          </Grid>
        </Grid>
      </NoSsr>
    </Container>
  );
};

SocialShare.propTypes = {
  fields: PropTypes.shape({
    key: PropTypes.object,
  }),
};

SocialShare.defaultProps = {
  fields: PropTypes.shape({
    key: { value: '' },
  }),
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(SocialShare))
);
